export default class MapField {
  constructor() {
    this.mappings = {};
    this.keyPaths = {};
    this._namespace = null;
    this._object = null;
    this._pathPrefix = null;
  }

  namespace(namespace) {
    this._namespace = namespace;
    return this;
  }

  object(obj) {
    this._object = _.cloneDeep(obj);
    return this;
  }

  pathPrefix(prefix) {
    this._pathPrefix = prefix;
    return this;
  }

  add(field, path, affix, storeGetter, storeAction) {
    let getNamespace = () => this._namespace;
    let getObj = () => this._object;

    let getPath = () => this._pathPrefix !== null ? [this._pathPrefix, path].join('.') : path;
    let getMutation = () => `${this._namespace}/setField`;

    storeGetter = affix ? 'get' + _.upperFirst(affix) : storeGetter;
    storeAction = affix ? 'set' + _.upperFirst(affix) : storeAction;

    let getGetter = () => storeGetter ? `${this._namespace}/${storeGetter}` : null;
    let getAction = () => storeAction ? `${this._namespace}/${storeAction}` : null;

    this.keyPaths[field] = path;

    this.mappings[field] = {
      get() {
        let namespace = getNamespace();
        let obj = getObj();

        let path = getPath();
        let getter = getGetter();

        if (obj) {
          return _.get(obj, getPath(), null)
        } else if (getter) {
          return this.$store.getters[getter](path)
        } else if (namespace) {
          return _.get(this.$store.state[namespace], getPath(), null);
        } else {
          return null;
        }
      },
      set(value) {
        let obj = getObj();

        let action = getAction();

        let setPath = getPath();

        if (obj) {
          return _.set(obj, getPath(), value)
        } else if (action !== null) {
          this.$store.dispatch(action, {path: setPath, value})
        } else {
          this.$store.commit({
            type: getMutation(),
            path: setPath,
            value
          });
        }
      }
    };
    return this;
  }

  get() {
    return this.mappings;
  }
}

export const mapFieldMutation = function () {
  return {
    setField(state, {path, value}) {
      _.set(state, path, value);
    }
  }
};